'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'ball-pile';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f77e';
var svgPathData = 'M368 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM232 80a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm32 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-136 0a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm296 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-136a88 88 0 1 1 0 176 88 88 0 1 1 0-176zM368 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-136 0a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zM112 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-136a88 88 0 1 1 0 176 88 88 0 1 1 0-176zm464 88a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-136 0a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBallPile = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;